import { storage } from 'APP/packages/storage';

export const saveOAuthReturnUrl = (state: string): void => {
  const returnUrl = window.location.search || '';

  if (!state || !returnUrl) {
    return;
  }

  storage.oauthReturnUrl.setOAuthReturnUrl(state, returnUrl);
};

export const getAndClearOAuthReturnUrl = (state: string | null): string => {
  const returnUrl = storage.oauthReturnUrl.getOAuthReturnUrl(state);

  if (returnUrl) {
    storage.oauthReturnUrl.clearOAuthReturnUrl(state);
  }

  return returnUrl;
};
